import { createIdentifier } from '@wix/thunderbolt-ioc'
import { BrowserWindow } from '../types'

export const BrowserWindowSymbol = createIdentifier<NonNullable<BrowserWindow>>(Symbol('BrowserWindow'))
export const ViewerModelSym = Symbol('ViewerModel')
export const LanguageSymbol = Symbol('Language')
export const ViewModeSym = Symbol('ViewMode')
export const RendererPropsExtenderSym = Symbol('RendererPropsExtenderSym')
export const ComponentLibrariesSymbol = Symbol('ComponentLibraries')
export const LoggerSymbol = Symbol('LOG')
export const MockModulesForTestsSymbol = Symbol('MockModulesForTestsSymbol')
export const PlatformEnvDataProviderSymbol = Symbol('PlatformEnvDataProviderSymbol')
export const PlatformViewportAPISym = Symbol('PlatformViewportAPISym')
export const WixCodeSdkHandlersProviderSym = Symbol('WixCodeSdkHandlersProviderSym')
export const StoresProviderSymbol = Symbol('storesProviderSymbol')
export const PlatformSymbol = Symbol('PlatformSymbol')
export const PlatformWorkerPromiseSym = Symbol('PlatformWorkerPromiseSym')
export const AppDidMountPromiseSymbol = Symbol('AppDidMountPromiseSymbol')
export const RendererSymbol = Symbol('RendererSymbol')
export const BatchingStrategySymbol = Symbol('BatchingStrategySymbol')
export const DomReadySymbol = Symbol('DomReady')
export const ReactContextSymbol = Symbol('ReactContext')
export const PlatformPropsSyncManagerSymbol = Symbol('PlatformPropsSyncManager')
export const DynamicModelSymbol = Symbol('DynamicModel')
export const FetchAccessTokensSymbol = Symbol('FetchAccessTokens')
export const RendererExtensionsSymbol = Symbol('RendererExtensionsSymbol')
export const MawSdkSymbol = Symbol('MawSdkSymbol')
export const NotifyErrorSymbol = Symbol('NotifyErrorSymbol')
export const AuthenticationSymbol = Symbol('AuthenticationSymbol')
export const PerfReporterSymbol = Symbol('PerfReporterSymbol')
export const WorkerIframeWrapperManagerSymbol = Symbol('WorkerIframeWrapperManager')
export const TBReadySymbol = Symbol('TBReadySymbol')
export const SessionProviderSymbol = Symbol('SessionProvider')
